// extracted by mini-css-extract-plugin
export default {"back":"Tools_back__+Vidi"};